import {useStyles} from '@wix/tpa-settings/react'
import {LIST_LAYOUT, MOBILE_WIDGET_LAYOUT} from '@wix/wix-events-commons-statics'
import {useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {useSettings} from '../../../../../commons/hooks/use-settings'
import {isMobile} from '../../../../../commons/selectors/environment'
import settingsParams from '../../../settingsParams'
import stylesParams from '../../../stylesParams'
import {useWidgetState} from '../../hooks/state-provider'
import sc from '../classes.scss'
import {Spinner} from '../spinner'
import {TodayButtonProps} from './interfaces'
import s from './today-button.scss'

export const TodayButton = ({dataHook, loading, onClick}: TodayButtonProps) => {
  const {t} = useTranslation()
  const {get: getSetting} = useSettings()
  const {get} = useStyles()

  const todayButtonText = getSetting(settingsParams.todayButtonText)
  const mobile = useWidgetState(isMobile)
  const calendar = mobile
    ? get(stylesParams.mobileWidgetLayoutNew) === MOBILE_WIDGET_LAYOUT.CALENDAR
    : get(stylesParams.listLayout) === LIST_LAYOUT.CALENDAR

  return (
    <div className={classNames(s.container, {[s.mobile]: mobile})}>
      {loading ? <Spinner calendarButton className={s.loader} diameter={20} /> : null}
      <button
        data-hook={dataHook}
        onClick={() => onClick()}
        type="button"
        className={classNames(s.button, sc.ellipsis, {
          [s.mobileList]: mobile && !calendar,
          [s.loading]: loading,
          [s.hoverColor]: !mobile,
        })}
      >
        {todayButtonText || t('layout.calendar.monthly.controls.today')}
      </button>
    </div>
  )
}
